// Core
import React from "react"

import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"
import Paragraph from "../../../../../../components/Paragraph"
import CTALink from "../../../../../../components/CTALink"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  margin-left: 12rem;
  margin-top: 2.3rem;

  p {
    margin-top: 3rem;
    width: 100%;
    max-width: 500px;
  }

  .contact {
    text-decoration: none;
    font-weight: 600;
    color: #60a6dd;
    word-break: break-all;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 6rem;
    margin-left: 0px;
  }
`

export default function CopyContainer() {
  return (
    <Container>
      <Title>Nossos contatos</Title>

      <Paragraph>
        Estamos à sua disposição. Junte-se a nós e entre em contato com a gente.
      </Paragraph>

      <Paragraph>
        <b>Tel.:</b>{" "}
        <a className="contact" href="tel:+556130480602">
          (61) 3048-0602
        </a>
      </Paragraph>

      <Paragraph>
        <a className="contact" href="mailto:contato@oceanodagraca.com">
          contato@oceanodagraca.com
        </a>
      </Paragraph>

      <CTALink
        greenDullLimeBG
        lightText
        rel="noopener"
        href="https://api.whatsapp.com/send?phone=5561996545717"
        target="_blank"
      >
        WHATSAPP
      </CTALink>
    </Container>
  )
}
